"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Boot = void 0;

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _palette = require("@artsy/palette");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _ = require("./..");

var _react = _interopRequireWildcard(require("react"));

var _reactHead = require("react-head");

var _sharify = require("sharify");

var _unstated = require("unstated");

var _BreakpointVisualizer = require("../../Utils/BreakpointVisualizer");

var _Events = _interopRequireDefault(require("../../Utils/Events"));

var _getENV = require("../../Utils/getENV");

var _ErrorBoundary = require("./ErrorBoundary");

var _Responsive = require("../../Utils/Responsive");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _injectGlobalStyles = (0, _palette.injectGlobalStyles)(),
    GlobalStyles = _injectGlobalStyles.GlobalStyles;

var Boot = (0, _.track)(null, {
  dispatch: _Events.default.postEvent
})(function (props) {
  /**
   * Let our end-to-end tests know that the app is hydrated and ready to go; and
   * if in prod, initialize Sentry.
   */
  (0, _react.useEffect)(function () {
    document.body.setAttribute("data-test", "AppReady"); //

    if ((0, _getENV.getENV)("NODE_ENV") === "production") {
      Sentry.init({
        dsn: _sharify.data.SENTRY_PUBLIC_DSN
      });
    }
  }, []);

  var children = props.children,
      context = props.context,
      _props$headTags = props.headTags,
      headTags = _props$headTags === void 0 ? [] : _props$headTags,
      onlyMatchMediaQueries = props.onlyMatchMediaQueries,
      rest = _objectWithoutProperties(props, ["children", "context", "headTags", "onlyMatchMediaQueries"]);

  var contextProps = _objectSpread({}, rest, context);

  return _react.default.createElement(_palette.Theme, null, _react.default.createElement(_reactHead.HeadProvider, {
    headTags: headTags
  }, _react.default.createElement(_unstated.Provider, null, _react.default.createElement(_.SystemContextProvider, contextProps, _react.default.createElement(_ErrorBoundary.ErrorBoundary, null, _react.default.createElement(_Responsive.MediaContextProvider, {
    onlyMatch: onlyMatchMediaQueries
  }, _react.default.createElement(_Responsive.ResponsiveProvider, {
    mediaQueries: _palette.themeProps.mediaQueries,
    initialMatchingMediaQueries: onlyMatchMediaQueries
  }, _react.default.createElement(_palette.Grid, {
    fluid: true,
    maxWidth: "100%"
  }, _react.default.createElement(GlobalStyles, null), children, process.env.NODE_ENV === "development" && _react.default.createElement(_BreakpointVisualizer.BreakpointVisualizer, null)))))))));
});
exports.Boot = Boot;
//# sourceMappingURL=Boot.js.map